export default "__VITE_ASSET__449f961c__"